import {FC, ReactNode, useMemo} from 'react';
import imgDef from '../../assets/project.svg';
import { ProjectCardDraftWrapper } from './styles';
import { FlexBox, Skeleton } from '@brg/ui';
import { ProjectCardDraftWrapperNew } from './stylesNew';
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import { CoverImage } from './projectCardLayoutNew';
import styled, {css} from 'styled-components';
import {LayoutConst} from "../../../core";
import { AppTester } from 'supporting';

export interface ProjectCardDraftLayoutProps {
    isLoading?: boolean;
    img?: string;
    identifier?: string;
    onClick?: (identifier: string) => void;
    more?: ReactNode;
    title?: ReactNode;
    delete?: ReactNode;
    projectType?: string;
    hasTitle?: boolean;
    metaAlwaysVisible?: boolean;
}

const MoreWrapper = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    z-index: 2;
`

const TitleWrapper = styled(FlexBox)<{isOutsidePsn?: boolean}>`
  min-height: 32px;
  
  ${({isOutsidePsn}) => isOutsidePsn && css`

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
      align-items: flex-start;
      min-height: ${LayoutConst.projectCard.m.h - LayoutConst.projectCard.m.h1_9 - 32}px;
    }
    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
      min-height: ${LayoutConst.projectCard.l.h - LayoutConst.projectCard.l.h1_9 - 32}px;
    }   
  `}
`

const DRAFT_CARD_COVER_GRADIENT =
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(24, 26, 28, 0) 0.01%, rgba(24, 26, 28, 0.85) 100%)';

const DraftCardCoverImageStack = styled.div<{ viewType?: string }>`
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    overflow: hidden;
    pointer-events: none;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ viewType }) =>
            ['t-shape', 'fixed-ratio-large'].includes(String(viewType || ''))
                ? css`
                      height: ${LayoutConst.projectCard.l.h1_9}px;
                      bottom: auto;
                  `
                : css``}
    }

    @media (max-width: ${LayoutConst.screen.l + 'px'}) {
        height: 100%;
        bottom: 0;
    }
`;

const DraftCardCoverGradient = styled.div`
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    background: ${DRAFT_CARD_COVER_GRADIENT};
`;

const DraftCardCoverImg = styled.img<{ viewType?: string }>`
    position: absolute;
    z-index: 0;
    display: block;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${({ viewType }) =>
        ['t-shape', 'fixed-ratio-large'].includes(String(viewType || ''))
            ? css`
                  object-position: top center;
              `
            : css`
                  object-position: center center;
              `}
`;

export const ProjectCardDraftLayout: FC<ProjectCardDraftLayoutProps> = (props) => {
    const { isLoading, img, onClick, identifier, more, title } = props;
    return (
        <ProjectCardDraftWrapper
            onClick={() => {
                onClick?.(identifier ?? '');
            }}
            img={img ?? imgDef}
        >
            <FlexBox className='meta' width={'100%'} justify={'flex-start'}>
                {isLoading ? null : more}
            </FlexBox>
            <FlexBox width={'100%'} style={{ minHeight: '32px' }} offsetBottom={8}>
                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
            </FlexBox>
        </ProjectCardDraftWrapper>
    );
};

export const ProjectCardDraftLayoutNew: FC<ProjectCardDraftLayoutProps> = (props) => {
    const { isLoading, img, onClick, identifier, more, title, projectType, hasTitle, metaAlwaysVisible } = props;
    const isDoubleGrid = useIsDoubleGrid();
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();

    const isOutsidePsn = useMemo(() => Boolean(['t-shape', 'fixed-ratio-large']?.includes(projectType || '') && img), [projectType, img])

    return (
        <ProjectCardDraftWrapperNew
            onClick={(ev: any) => {
                if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
                    return
                }
                onClick?.(identifier ?? '');
            }}
            img={( img ?? "")}
            hasTitle={hasTitle}
            noGrid={!isDoubleGrid}
            viewType={projectType}
            metaAlwaysVisible={metaAlwaysVisible}
        >
            {img ? (
                <DraftCardCoverImageStack aria-hidden viewType={projectType}>
                    <DraftCardCoverImg
                        src={img}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        viewType={projectType}
                    />
                    <DraftCardCoverGradient />
                </DraftCardCoverImageStack>
            ) : (
                <CoverImage
                    absolute
                    showDefaultPlaceholder
                    isCGRAVE={isCGRAVE || isContinuumSite}
                    isSquare={false}
                />
            )}
            <MoreWrapper>
                <FlexBox className='meta' width={'100%'} justify={'flex-start'}>
                    {isLoading ? null : more}
                    {isLoading ? null : props?.delete}
                </FlexBox>
                <TitleWrapper isOutsidePsn={isOutsidePsn} width={'100%'} offsetBottom={0} align={'flex-end'} className={'title-wrapper'}>
                    {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                </TitleWrapper>
            </MoreWrapper>
        </ProjectCardDraftWrapperNew>
    );
};
import {FC, ReactNode, useMemo} from 'react';
import imgDef from '../../assets/project.svg';
import { ProjectCardDraftWrapper } from './styles';
import { FlexBox, Skeleton } from '@brg/ui';
import { ProjectCardDraftWrapperNew } from './stylesNew';
import useIsDoubleGrid from "../../hooks/useIsDoubleGrid";
import { CoverImage } from './projectCardLayoutNew';
import styled, {css} from 'styled-components';
import {LayoutConst} from "../../../core";
import { AppTester } from 'supporting';

export interface ProjectCardDraftLayoutProps {
    isLoading?: boolean;
    img?: string;
    identifier?: string;
    onClick?: (identifier: string) => void;
    more?: ReactNode;
    title?: ReactNode;
    delete?: ReactNode;
    projectType?: string;
    hasTitle?: boolean;
    metaAlwaysVisible?: boolean;
}

const MoreWrapper = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    z-index: 2;
`

const TitleWrapper = styled(FlexBox)<{isOutsidePsn?: boolean}>`
  min-height: 32px;
  
  ${({isOutsidePsn}) => isOutsidePsn && css`

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
      align-items: flex-start;
      min-height: ${LayoutConst.projectCard.m.h - LayoutConst.projectCard.m.h1_9 - 32}px;
    }
    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
      min-height: ${LayoutConst.projectCard.l.h - LayoutConst.projectCard.l.h1_9 - 32}px;
    }   
  `}
`

const DRAFT_CARD_COVER_GRADIENT =
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(24, 26, 28, 0) 0.01%, rgba(24, 26, 28, 0.85) 100%)';

const DraftCardCoverImageStack = styled.div<{ viewType?: string }>`
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    overflow: hidden;
    pointer-events: none;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ viewType }) =>
            ['t-shape', 'fixed-ratio-large'].includes(String(viewType || ''))
                ? css`
                      height: ${LayoutConst.projectCard.l.h1_9}px;
                      bottom: auto;
                  `
                : css``}
    }

    @media (max-width: ${LayoutConst.screen.l + 'px'}) {
        height: 100%;
        bottom: 0;
    }
`;

const DraftCardCoverGradient = styled.div`
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    background: ${DRAFT_CARD_COVER_GRADIENT};
`;

const DraftCardCoverImg = styled.img<{ viewType?: string }>`
    position: absolute;
    z-index: 0;
    display: block;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${({ viewType }) =>
        ['t-shape', 'fixed-ratio-large'].includes(String(viewType || ''))
            ? css`
                  object-position: top center;
              `
            : css`
                  object-position: center center;
              `}
`;

export const ProjectCardDraftLayout: FC<ProjectCardDraftLayoutProps> = (props) => {
    const { isLoading, img, onClick, identifier, more, title } = props;
    return (
        <ProjectCardDraftWrapper
            onClick={() => {
                onClick?.(identifier ?? '');
            }}
            img={img ?? imgDef}
        >
            <FlexBox className='meta' width={'100%'} justify={'flex-start'}>
                {isLoading ? null : more}
            </FlexBox>
            <FlexBox width={'100%'} style={{ minHeight: '32px' }} offsetBottom={8}>
                {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
            </FlexBox>
        </ProjectCardDraftWrapper>
    );
};

export const ProjectCardDraftLayoutNew: FC<ProjectCardDraftLayoutProps> = (props) => {
    const { isLoading, img, onClick, identifier, more, title, projectType, hasTitle, metaAlwaysVisible } = props;
    const isDoubleGrid = useIsDoubleGrid();
    const isCGRAVE = AppTester.isCGRAVE();
    const isContinuumSite = AppTester.isContinuumSite();

    const isOutsidePsn = useMemo(() => Boolean(['t-shape', 'fixed-ratio-large']?.includes(projectType || '') && img), [projectType, img])

    return (
        <ProjectCardDraftWrapperNew
            onClick={(ev: any) => {
                if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
                    return
                }
                onClick?.(identifier ?? '');
            }}
            img={( img ?? "")}
            hasTitle={hasTitle}
            noGrid={!isDoubleGrid}
            viewType={projectType}
            metaAlwaysVisible={metaAlwaysVisible}
        >
            {img ? (
                <DraftCardCoverImageStack aria-hidden viewType={projectType}>
                    <DraftCardCoverImg
                        src={img}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        viewType={projectType}
                    />
                    <DraftCardCoverGradient />
                </DraftCardCoverImageStack>
            ) : (
                <CoverImage
                    absolute
                    showDefaultPlaceholder
                    isCGRAVE={isCGRAVE || isContinuumSite}
                    isSquare={false}
                />
            )}
            <MoreWrapper>
                <FlexBox className='meta' width={'100%'} justify={'flex-start'}>
                    {isLoading ? null : more}
                    {isLoading ? null : props?.delete}
                </FlexBox>
                <TitleWrapper isOutsidePsn={isOutsidePsn} width={'100%'} offsetBottom={0} align={'flex-end'} className={'title-wrapper'}>
                    {isLoading ? <Skeleton height={32} width={'100%'} /> : title}
                </TitleWrapper>
            </MoreWrapper>
        </ProjectCardDraftWrapperNew>
    );
};
